// extracted by mini-css-extract-plugin
export var billingAddress = "_xg-g";
export var contactInfo = "_xg-d";
export var customerInfoContainer = "_xg-c";
export var customerInfoContainerMobile = "_xg-h";
export var customerInfoRow = "_xg-a";
export var customerInfoSection = "_xg-b";
export var fullWidthDividerMobile = "_xg-i";
export var imageContainer = "_xg-1";
export var paymentMethod = "_xg-e";
export var priceText = "_xg-6";
export var priceTextMobile = "_xg-7";
export var product = "_xg-0";
export var productImage = "_xg-2";
export var productInfo = "_xg-4";
export var productMobile = "_xg-9";
export var productTitle = "_xg-8";
export var quantityBadge = "_xg-3";
export var quantityText = "_xg-5";
export var shippingAddress = "_xg-f";